// Helper methods for motivation building

// Motivation dates
export const motivationWorkWithDates = {
  data() {
      return {
          monthRange: [],
          quartersRange: [],
          selectedMonth: null,
          selectedStartMonth: null,
          selectedEndMonth: null,
          selectedQuarter: null,
          selectedQuarterYear: null,
          months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
          quarters: [
            {
              name: "I квартал",
              firstMonth: "01",
              lastMonth: "03"
            },
            {
              name: "II квартал",
              firstMonth: "04",
              lastMonth: "06"
            },
            {
              name: "III квартал",
              firstMonth: "07",
              lastMonth: "09"
            },
            {
              name: "IV квартал",
              firstMonth: "10",
              lastMonth: "12"
            }
          ]
      }
  },
  mounted() {
      this.monthRangePrepare()
      this.quartersRangePrepare()
  },
  methods: {
      quartersRangePrepare() {
        this.setTodayQuarter()

        for (let year = new Date().getFullYear(); year >= 2022; year--) {
          this.quarters.forEach((quarter, index) => {
            if (year == 2022 && [0, 1].includes(index))
              return false;

            this.quartersRange.unshift({
              text: quarter.name + " " + year,
              value: year + "-" + quarter.firstMonth + "-01",
              month: quarter.firstMonth,
              year: year
            })
          })
        }
        //
        // this.monthRange.sort((a, b) => {
        //   return new Date(b.value) - new Date(a.value)
        // })
      },
      currentMonthWithConditions() {
        const dayOfNewStart = 7;
        const today = new Date();
        const currentMonth = (today.getMonth() + 1) > 12 ? 0 : (today.getMonth() + 1);
      
        const tenthDay = new Date(today.getFullYear(), today.getMonth(), dayOfNewStart).getDate();
      
        return {
          currentMonth: currentMonth,
          previousMonth: (currentMonth - 1) < 0 ? 11 : (currentMonth - 1),
          currentYear: today.getFullYear(),
          previousYear: (currentMonth - 1) < 0 ? today.getFullYear() - 1 : today.getFullYear(),
          take: (today.getDate() > tenthDay) ? 'current' : 'previous'
        }
      },
      monthRangePrepare() {
        this.setTodayMonth()
        const currentM = this.currentMonthWithConditions()

        // Определяем максимальный месяц для текущего года
        // Используем реальный текущий месяц, а не с учетом условий
        const today = new Date();
        const realCurrentMonthIndex = today.getMonth(); // 0-11
        let maxMonthIndex = realCurrentMonthIndex;

        for (let year = new Date().getFullYear(); year >= 2023; year--) {
          this.months.forEach((month, index) => {
            let numberOfMonth = ((index + 1) > 9) ? (index + 1) : ('0' + (index + 1))

            if (year == 2023 && ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь"].includes(month))
              return false;
            if (year == new Date().getFullYear()) {
              // Для текущего года добавляем все месяцы до текущего включительно
              if (index > maxMonthIndex) {
                return false;
              } else {
                this.monthRange.unshift({
                  text: month + " " + year,
                  value: year + "-" + numberOfMonth + "-01",
                  month: month,
                  monthNumber: numberOfMonth,
                  year: year
                })
              }
            } else {
              this.monthRange.unshift({
                text: month + " " + year,
                value: year + "-" + numberOfMonth + "-01",
                month: month,
                monthNumber: numberOfMonth,
                year: year
              })
            }
          })
        }

        this.monthRange.sort((a, b) => {
          return new Date(b.value) - new Date(a.value)
        })
      },
      setTodayMonth() {
        const currentM = this.currentMonthWithConditions()
        this.selectedMonth = this.$moment(currentM[currentM.take + 'Year'] + '-' + currentM[currentM.take + 'Month'] + '-01').format('YYYY-MM-DD')
      },
      setTodayMonthPreviouseVersion() {
        let todayDate = new Date()
        let todayYM = this.$moment(todayDate).format('YYYY-MM')
        let startDefaultDate = this.$moment(todayDate.setMonth(todayDate.getMonth() - 5)).format('YYYY-MM')

        this.selectedMonth = todayYM + '-01'

        this.selectedStartMonth = startDefaultDate + '-01'
        this.selectedEndMonth = todayYM + '-01'
      },
      setTodayQuarter() {
        let today = new Date()
        let nowQuarterElement = this.quarters[Math.floor((today.getMonth() + 3) / 3) - 1]

        this.selectedQuarterYear = today.getFullYear()
        this.selectedQuarter = this.selectedQuarterYear + "-" + nowQuarterElement.firstMonth + "-01"
      },
  }
}
